<div class="loader">
    <div class="loader-message" [textContent]="loaderMessage"></div>
    <div class="loader-spinner"></div>
</div>
